import type { SelectedItem } from '../SelectItems.types'

export const modifySelectedItem = (item: SelectedItem, selectedItems: SelectedItem[]) =>
  selectedItems.map((selectedItem) => {
    if (selectedItem.variantId === item.variantId) {
      return { ...item }
    }

    return selectedItem
  })
